// extracted by mini-css-extract-plugin
export default {"Wrapper":"NotificationTableHeader_Wrapper__TMy9S"};